import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";
  import { computed } from "vue";
  import { LotBaseInterface } from "@/types/LotInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  interface Props {
    isOpen: boolean;
    lot: LotBaseInterface;
    estate: EstateInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'TransferOwnershipModal',
  props: {
    isOpen: { type: Boolean },
    lot: {},
    estate: {}
  },
  emits: ["close", "proceed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }
  function proceed() {
    emits("proceed");
    close();
  }
  const lotOwnership = computed(() => {
    const { estate } = props;

    if (!estate.business || !estate.collaboratorBusiness) return "Any";

    const ownershipId =
      typeof props.lot.ownershipId === "object"
        ? props.lot.ownershipId?._id
        : props.lot.ownershipId;

    if (ownershipId === estate.business._id) {
      return estate.business.name;
    }

    return estate.collaboratorBusiness[0].name;
  });

  const newOwnership = computed(() => {
    const { estate } = props;

    if (!estate.business || !estate.collaboratorBusiness) return "Any";

    const ownershipId =
      typeof props.lot.ownershipId === "object"
        ? props.lot.ownershipId?._id
        : props.lot.ownershipId;

    if (ownershipId === estate.business._id) {
      return estate.collaboratorBusiness[0].name;
    }

    return estate.business.name;
  });

const __returned__ = { emits, props, close, proceed, lotOwnership, newOwnership, Modal, computed, get LotBaseInterface() { return LotBaseInterface }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})